<template>
  <div v-if="$auth.policies['view-survey']">
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="$route.meta.title"
          :link="[{ text: 'Học sinh', href: '#' }, { text: $route.meta.title }]"
        />
      </div>
      <div v-if="$auth.policies['update-survey']">
        <v-btn v-if="!survey.released" class="white--text" color="primary" @click="released">
          Mở khảo sát
        </v-btn>
        <v-btn v-else class="white--text" color="primary" @click="close">
          Đóng khảo sát
        </v-btn>
      </div>
    </div>
    <div class="pa-4">
      <InfoBasicView />
      <SurveyTab class="mt-4" />
    </div>
    <div v-if="$auth.policies['delete-survey']" class="pa-4 d-flex justify-center align-center">
      <v-btn outlined color="error" @click="removeSurvey(survey.id)"> <v-icon left>delete</v-icon>Xoá khảo sát </v-btn>
    </div>
  </div>
  <div v-else>
    <Page403></Page403>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import InfoBasicView from '../../../modules/survey/survey-detail/InfoBasicView.vue'
import SurveyTab from '../../../modules/survey/survey-detail/SurveyTab.vue'
import Page403 from '@/views/Page403.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: { Breadcrumbs, InfoBasicView, SurveyTab, Page403 },
  computed: {
    ...mapState({
      survey: state => state.survey.item
    })
  },
  created() {
    this.fetchOne(this.$route.params.id)
  },
  methods: {
    ...mapActions({
      fetchOne: 'survey/fetchOne',
      remove: 'survey/remove',
      update: 'survey/update'
    }),
    async removeSurvey(id) {
      this.$dialog.confirm({
        title: 'Xoá khảo sát',
        text: `Việc xoá khảo sát sẽ <span style="color: red">xoá tất cả các dữ liệu liên quan</span> của khảo sát này (câu hỏi, dữ liệu báo cáo, câu trả lời...) <br>Bạn có muốn xoá khảo sát?`,
        okText: 'Xoá',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.remove(id)
            this.$alert.success('Xoá thành công')
            this.$router.push('/survey')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    released() {
      this.$dialog.confirm({
        title: 'Phát hành khảo sát',
        text: `Sau khi phát hành khảo sát thì sẽ không được chỉnh sửa và phụ huynh có thể bắt đầu tham gia khảo sát.`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.survey.id, released: true, status: 'open' })
            this.fetchOne(this.$route.params.id)
            this.$alert.success('Đã phát hành khảo sát')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    close() {
      this.$dialog.confirm({
        title: 'Đóng khảo sát',
        text: `Sau khi đóng khảo sát thì phụ huynh sẽ không thể tham gia khảo sát nữa.`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.survey.id, status: 'close', released: false })
            this.fetchOne(this.$route.params.id)
            this.$alert.success('Đã đóng khảo sát')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
<style scoped></style>
